import React, { Component } from 'react';
import { Skeleton } from 'primereact/skeleton';
import Table from '../MapaRevendaLocacao/Table';

const TIPO_NEGOCIO_LABELS = { Venda: 'Revenda', Aluguel: 'Locação' };

/**
 * Painel direito de resultados do mapa de Revenda e Locação (Mapbox). Renderiza
 * um bloco por área pesquisada (cidade/estado ou forma desenhada) com: cabeçalho
 * (InfoCard), botões EXCEL/POLOS e a tabela de oferta por tipo (reuso da Table do
 * mapa Google). Substitui SlidingPanelEmpreendimento + InfoCard, sem jQuery.
 */
class ResultsPanel extends Component {
    renderAreaHeader(area) {
        const canExcel = !!window.canExportRevendaLocacao;
        const canPolos =
            window.authenticatedUserCanQueryPolos === true &&
            Array.isArray(area.polos_geradores) &&
            area.polos_geradores.length > 0;

        return (
            <div className="mrl-mapbox-area-header">
                <div className="mrl-mapbox-area-title">
                    <i className="fa-solid fa-circle" style={{ color: area.color || '#517E37' }} />{' '}
                    <strong>{area.name}</strong>
                </div>
                <div className="mrl-mapbox-area-meta">
                    <div><span>Tipo da Busca:</span> {area.typeLabel || area.type}</div>
                    {area.radius != null && (
                        <div><span>Raio do Círculo:</span> {Number(area.radius).toFixed(0)} m</div>
                    )}
                    <div><span>Total de Imóveis:</span> {Number(area.count_buildings || 0).toLocaleString('pt-BR')}</div>
                    <div><span>Tipo de Negócio:</span> {TIPO_NEGOCIO_LABELS[area.tipo_negocio] || area.tipo_negocio}</div>
                </div>
                <div className="mrl-mapbox-area-actions">
                    {canExcel && (
                        <button
                            type="button"
                            className="btn btn-sm btn-outline-success"
                            onClick={() => this.props.onExportExcel(area)}
                        >
                            <i className="fas fa-file-excel mr-1" /> EXCEL
                        </button>
                    )}
                    {canPolos && (
                        <button
                            type="button"
                            className="btn btn-sm btn-outline-primary"
                            onClick={() => this.props.onShowPolos(area)}
                        >
                            <i className="fas fa-store mr-1" /> POLOS
                        </button>
                    )}
                    <button
                        type="button"
                        className="btn btn-sm btn-outline-danger"
                        title="Remover área dos resultados"
                        onClick={() => this.props.onRemoveArea(area.id)}
                    >
                        <i className="fas fa-times" />
                    </button>
                </div>
            </div>
        );
    }

    render() {
        const { areas } = this.props;

        if (!areas || areas.length === 0) {
            return <p className="text-muted small p-3">Nenhuma área pesquisada.</p>;
        }

        return (
            <div className="mrl-mapbox-results">
                {areas.map((area) => (
                    <div className="mrl-mapbox-area" key={area.id}>
                        {this.renderAreaHeader(area)}

                        {area.loading ? (
                            <div className="p-2">
                                <Skeleton width="100%" height="2rem" className="mb-2" />
                                <Skeleton width="100%" height="2rem" className="mb-2" />
                                <Skeleton width="100%" height="2rem" />
                            </div>
                        ) : (
                            <Table
                                count_buildings={area.count_buildings}
                                metadata={area.metadata ?? []}
                                metadataQuartos={area.metadataQuartos ?? []}
                                metadataPadrao={area.metadataPadrao ?? []}
                                color={area.color}
                                title={area.tipo_negocio}
                            />
                        )}
                    </div>
                ))}
            </div>
        );
    }
}

export default ResultsPanel;
